module.exports = __webpack_public_path__ + "static/img/illustrator_coreapp_01.b54a676.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bidding/illustrator_coreapp_01.svg
// module id = 568
// module chunks = 12